/* Reuse the original menu, predictive search and cart; no clones or requests. */
(() => {
  if (window.dsvMobileScrollInstalled) return;
  window.dsvMobileScrollInstalled = true;
  let current;

  function mount() {
    current?.destroy();
    current = null;
    const inner = document.querySelector('#header-inner[data-dsv-mobile-scroll]');
    if (!inner || inner.dataset.dsvMobileScroll === 'off' ||
        (inner.dataset.dsvMobileScroll === 'home' && inner.dataset.dsvHomepage !== 'true')) return;
    const header = inner.closest('#header');
    const menu = inner.querySelector('.dsv-mobile-navigation');
    const search = inner.querySelector('#search');
    const input = search?.querySelector('[name="q"]');
    if (!header || !menu || !input || !window.IntersectionObserver) return;

    const html = document.documentElement;
    const media = matchMedia('(max-width:760px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const opts = {signal: abort.signal};
    const originalPlaceholder = input.getAttribute('placeholder');
    const originalHeight = header.style.height;
    const anchor = document.createElement('span');
    anchor.className = 'dsv-scroll-anchor';
    anchor.setAttribute('aria-hidden', 'true');
    header.append(anchor);
    let enabled = false, active = false, frame = 0, lastWidth = window.innerWidth;
    let observer;
    // Start before the old search field leaves the viewport. Use a separate
    // return point so tiny up/down movements cannot repeatedly restart the effect.
    const enterAt = 72, returnAt = 112;
    const stopMotion = () => inner.classList.remove('dsv-scroll-entering', 'dsv-scroll-returning');

    const busy = () => menu.open || search.contains(document.activeElement);
    const viewport = () => {
      const visual = window.visualViewport;
      inner.style.setProperty('--dsv-visual-height', `${visual?.height || window.innerHeight}px`);
      inner.style.setProperty('--dsv-visual-top', `${visual?.offsetTop || 0}px`);
    };
    function setActive(value, force = false) {
      if (value === active || (!force && busy())) return;
      stopMotion();
      if (value) {
        // Reserve exactly the old header's space before taking its controls out of flow.
        header.style.height = `${header.getBoundingClientRect().height}px`;
        inner.classList.add('dsv-scroll-compact');
        html.classList.add('dsv-mobile-scroll-active');
        input.setAttribute('placeholder', inner.dataset.dsvCompactPlaceholder || originalPlaceholder || '');
        if (!force && !reducedMotion.matches) inner.classList.add('dsv-scroll-entering');
      } else {
        inner.classList.remove('dsv-scroll-compact');
        html.classList.remove('dsv-mobile-scroll-active');
        header.style.height = originalHeight;
        if (originalPlaceholder === null) input.removeAttribute('placeholder');
        else input.setAttribute('placeholder', originalPlaceholder);
        if (!force && enabled && !reducedMotion.matches) inner.classList.add('dsv-scroll-returning');
      }
      active = value;
      observeBoundary();
      viewport();
    }
    function sync() {
      frame = 0;
      if (!enabled) return;
      setActive(anchor.getBoundingClientRect().bottom <= (active ? returnAt : enterAt));
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    function observeBoundary() {
      observer?.disconnect();
      if (!enabled) return;
      observer = new IntersectionObserver(schedule, {
        rootMargin: `-${active ? returnAt : enterAt}px 0px 0px 0px`, threshold: [0, 1]
      });
      observer.observe(anchor);
    }
    function responsive() {
      enabled = media.matches;
      anchor.hidden = !enabled;
      html.classList.toggle('dsv-mobile-scroll-ready', enabled);
      observer?.disconnect();
      if (!enabled) setActive(false, true);
      else { observeBoundary(); schedule(); }
      if (!enabled) stopMotion();
      viewport();
    }
    media.addEventListener('change', responsive, opts);
    reducedMotion.addEventListener('change', stopMotion, opts);
    inner.addEventListener('animationend', event => {
      if (event.target === inner && event.animationName.startsWith('dsv-scroll-')) stopMotion();
    }, opts);
    // Controls stay still as soon as the visitor starts using them.
    inner.addEventListener('pointerdown', stopMotion, opts);
    inner.addEventListener('focusin', stopMotion, opts);
    window.addEventListener('resize', () => {
      // A keyboard changes the viewport height, not the layout width: do not reset it.
      if (lastWidth !== window.innerWidth) {
        lastWidth = window.innerWidth;
        if (active) {
          menu.open = false;
          if (search.contains(document.activeElement)) document.activeElement.blur();
          setActive(false, true);
        }
        schedule();
      }
      viewport();
    }, opts);
    window.addEventListener('pageshow', schedule, opts);
    window.visualViewport?.addEventListener('resize', viewport, opts);
    window.visualViewport?.addEventListener('scroll', viewport, opts);
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        search.classList.remove('full', 'has-text', 'not-empty');
        html.classList.remove('search-full', 'search-full-mode', 'search-focus');
      }
      schedule();
    }, opts);
    search.addEventListener('focusin', () => { menu.open = false; }, opts);
    inner.addEventListener('focusout', schedule, opts);
    document.addEventListener('pointerdown', event => {
      if (!enabled) return;
      if (!menu.contains(event.target)) menu.open = false;
      if (active && !inner.contains(event.target)) {
        search.classList.remove('full', 'has-text', 'not-empty');
        html.classList.remove('search-full', 'search-full-mode', 'search-focus');
        if (search.contains(document.activeElement)) document.activeElement.blur();
      }
      schedule();
    }, opts);
    inner.addEventListener('keydown', event => {
      if (!enabled || event.key !== 'Escape') return;
      if (menu.open) {
        event.preventDefault();
        event.stopPropagation();
        menu.open = false;
        menu.querySelector('summary').focus({preventScroll:true});
      } else if (search.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        search.classList.remove('full', 'has-text', 'not-empty');
        html.classList.remove('search-full', 'search-full-mode', 'search-focus');
        input.blur();
      }
      schedule();
    }, opts);
    menu.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      menu.open = false;
      // The existing homepage menu handler opens the game finder.
      schedule();
    }, opts);
    responsive();
    current = {element: inner, destroy() {
      abort.abort(); enabled = false; observer?.disconnect(); cancelAnimationFrame(frame);
      setActive(false, true); stopMotion(); anchor.remove();
      inner.style.removeProperty('--dsv-visual-height');
      inner.style.removeProperty('--dsv-visual-top');
      html.classList.remove('dsv-mobile-scroll-ready');
    }};
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('#header-inner')) mount();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (current && event.target.contains(current.element)) { current.destroy(); current = null; }
  });
})();
